import StepHeader from "../ui/stepHeader";
import { Label } from "@/components/ui/label";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { VideoInteraction, VideoInteractionType } from "@yedalabs/schema";
import { useInteractions } from "../../hooks/interactionsProvider";
import { defaultContentForType, interactionTypeOptions } from "../../lib/utils";
import TimestampInput from "@/components/ui/timestamp-input";
import ContinueButton from "../ui/continueButton";
import { t } from "@/lib/localization";
import { useLocale } from "@/hooks/useLocale";

export default function TimeAndTypeStep() {
    const { dir } = useLocale();
    const { selectedInteraction, updateInteraction } = useInteractions();

    if (!selectedInteraction) return <></>;

    return (
        <div className="flex flex-col gap-6 w-full">
            <StepHeader
                title={{
                    keyName:
                        "interaction-modal.time-and-type-step.header.title",
                    defaultValue: "זמן וסוג",
                }}
                description={{
                    keyName:
                        "interaction-modal.time-and-type-step.header.description",
                    defaultValue: "בחרו מתי האינטראקציה תופיע ואת הסוג שלה",
                }}
            />

            <div className="flex flex-col gap-2">
                <Label htmlFor="interactionTimestamp">
                    {t(
                        "interaction-modal.timestamp.label",
                        undefined,
                        undefined
                    )}
                </Label>

                <TimestampInput
                    valueInSeconds={selectedInteraction.timestamp}
                    onValueChange={(value) =>
                        updateInteraction(selectedInteraction!.id, {
                            timestamp: value,
                        })
                    }
                    align="start"
                    showMs
                />
            </div>

            <div className="flex flex-col gap-2 w-full">
                <Label htmlFor="selectInteractionType">
                    {t("interaction-modal.select-type.label")}
                </Label>
                <Select
                    value={selectedInteraction?.type}
                    onValueChange={(value) => {
                        const nextType = value as VideoInteractionType;
                        if (nextType === selectedInteraction.type) return;
                        updateInteraction(selectedInteraction!.id, {
                            type: nextType,
                            content: defaultContentForType(nextType),
                        } as Partial<VideoInteraction>);
                    }}
                    dir={dir}
                >
                    <SelectTrigger className="h-9">
                        <SelectValue
                            placeholder={t(
                                "interaction-modal.select-type.placeholder"
                            )}
                            placeholderKeyName="interaction-modal.select-type.placeholder"
                        />
                    </SelectTrigger>
                    <SelectContent>
                        {interactionTypeOptions.map((type) => (
                            <SelectItem key={type.id} value={type.id}>
                                {t(type.keyName)}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>

            <ContinueButton />
        </div>
    );
}
